// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"8bcfed04","549":"da5001bc"}[chunkId] + ".chunk.css";
};